import ComicBox from 'component/ComicBox'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Wrapper } from './Styled'
import EffectStack from 'swiperEffects/cardStack'
import { memo, useCallback, useState } from 'react'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'
import { useDuplicatedArray } from 'hooks/useDuplicatedArray'
import { selectStation } from 'redux/selector/app'
import { useSelector } from 'react-redux'
import { AreaBoxSwiperTemplateWrapper, MaskedAesBackground } from '../Styled'

interface Template205Props {
  videoData?: any[]
}

function Template205({ videoData: videoDataProp }: Template205Props) {
  const videoData = useDuplicatedArray(videoDataProp ?? [], 5)

  const [currentSlide, setCurrentSlide] = useState(0)

  const currentItem: any = videoData[currentSlide]

  const station = useSelector(selectStation)
  const currentImage = currentItem?.cover_url

  const onSlideChange = useCallback((swiper: any) => {
    setCurrentSlide(swiper.realIndex)
  }, [])

  const { ref, visible } = useIntersectionObserver<HTMLDivElement>({
    /* Optional options */
    defaultVisible: false,
    threshold: 0,
    triggerOnce: false,
  })

  return (
    <AreaBoxSwiperTemplateWrapper>
      <Wrapper ref={ref as React.RefObject<HTMLDivElement>}>
        <MaskedAesBackground
          className={'swiper-no-swiping'}
          decryptKey={station.cover_key}
          src={currentImage}
          noLazy={visible}
          source="comic"
          allowUnload
          useExternalHeight
        />
        <Swiper
          effect="stack"
          onSlideChange={onSlideChange}
          modules={[EffectStack]}
          virtualTranslate={true}
          loop={true}
          nested={true}
        >
          {videoData?.map((item, i) => {
            return (
              <SwiperSlide key={item.id}>
                <ComicBox
                  noDecoration
                  overflow={true}
                  style={{ textAlign: 'center' }}
                  comicInfo={item}
                  width="auto"
                  titleInSlide
                  noLazy={visible}
                  fontSize={'0.41rem'}
                  allowUnload
                  hideTags
                />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </Wrapper>
    </AreaBoxSwiperTemplateWrapper>
  )
}
export default memo(Template205)
